module.exports = __webpack_public_path__ + "assets/img/hcpimg4r.eb7b4a01.png";